import React from "react";

export default function XPBar({ xp, xpToNext, level }) {
  const pct = Math.min(100, Math.round((xp / Math.max(1, xpToNext)) * 100));
  return (
    <div data-testid="xp-bar" className="w-full">
      <div className="flex items-baseline justify-between mb-2">
        <div className="label-tech">Experience</div>
        <div className="font-mono-tech text-xs text-slate-400">
          <span className="text-cyan-400">{xp}</span> / {xpToNext} XP
        </div>
      </div>
      <div className="xp-track">
        <div className="xp-fill" style={{ width: `${pct}%` }} data-testid="xp-fill" />
      </div>
      <div className="mt-1.5 flex items-center justify-between text-[0.65rem] font-mono-tech text-slate-500">
        <span>LVL {level}</span>
        <span>NEXT: LVL {level + 1}</span>
      </div>
    </div>
  );
}
